export { IrLibraryPage as default } from '@/components/enpages/Ir/Library'
